import './mayaguez/style';
import FormStructure from './mayaguez/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/kevin/projects/inquiry-renderer/client_forms/includes.js